import DOMPurify from 'dompurify'
import { marked } from 'marked'
import { Box } from '@mantine/core'

// Open every rendered link in a new tab so clicking a link inside a beat,
// dossier document, or chat message doesn't navigate the player away from the
// game. Registered once at module load (the hook is global to DOMPurify).
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('href')) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

export function MarkdownRenderer({ content = '', style = {} }) {
  const sanitizedHtml = DOMPurify.sanitize(
    marked.parse(content?.toString() || '')
  )

  return (
    <Box
      className="markdown-content"
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  )
}
